module.exports = "/images/vendor/flag-icon-css/flags/4x3/sg.svg?5e6ed3f10d1de224079d77fe6f59ce97";